/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IERC20MetadataUpgradeable__factory } from "./IERC20MetadataUpgradeable__factory";
